import React, { useEffect, useState, SyntheticEvent } from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import {Form, Button} from 'react-bootstrap';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { useUser } from '../../contexts/UserContext';

const PASSWORD_REQUIREMENTS = [
    { test: (p) => p.length >= 12, label: 'At least 12 characters' },
    { test: (p) => /[A-Z]/.test(p), label: 'At least 1 uppercase letter' },
    { test: (p) => /[a-z]/.test(p), label: 'At least 1 lowercase letter' },
    { test: (p) => /[0-9]/.test(p), label: 'At least 1 number' },
    { test: (p) => /[^A-Za-z0-9]/.test(p), label: 'At least 1 special character' },
];

const MemberForm = (props) => {
    const [FirstName, setFirstName] = useState('');
    const [LastName, setLastName] = useState('');
    const [Email, setEmail] = useState('');
    const [Role, setRole] = useState('');
    const [Roles, setRoles] = useState([]);
    const [Enabled, setEnabled] = useState(true);
    const [AccountPassword, setAccountPassword] = useState('');
    const [AccountConfirmPassword, setAccountConfirmPassword] = useState('');
    const [passwordErrors, setPasswordErrors] = useState([]);
    const { user: account } = useUser();
    const [id, setId] = useState(props?.location?.aboutProps?.id);
    const [loadingData, setLoadingData] = useState(false);
    const history = useHistory();
    const isEdit = id > 0;

    const getById = async () => {
        if (id > 0) {
            setLoadingData(true);
            try {
                api.get("member/" + id )
                    .then(function (response) {
                        if (response.status == 200) {
                            var result = response.data;
                            setFirstName(result.first_name);
                            setLastName(result.last_name);
                            setEmail(result.email);
                            setRole(result.role);
                            setEnabled(result.is_active);
                        }
                        setLoadingData(false);
                    })
                    .catch(function (error) {
                        toast.error('An error occurred !', {
                            position: toast.POSITION.TOP_RIGHT
                        });
                        setLoadingData(false);
                    });
            } catch (err) {
                toast.error('An error occurred !', {
                    position: toast.POSITION.TOP_RIGHT
                });
                setLoadingData(false);
            }
        }
    }

    const validatePassword = (password) => {
        return PASSWORD_REQUIREMENTS.filter(req => !req.test(password)).map(req => req.label);
    };

    const saveData = async (e) => {
        e.preventDefault();

        if (AccountPassword || !isEdit) {
            const errors = validatePassword(AccountPassword);
            if (errors.length > 0) {
                setPasswordErrors(errors);
                return;
            }
            if (AccountPassword !== AccountConfirmPassword) {
                toast.error('Passwords do not match.', { position: toast.POSITION.TOP_RIGHT });
                return;
            }
        }
        setPasswordErrors([]);

        setLoadingData(true);
        try {
            if (isEdit) {
                const data = {
                    first_name: FirstName,
                    last_name: LastName,
                    email: Email,
                    role: Role,
                    is_active: Enabled
                };
                if (AccountPassword) {
                    data.password = AccountPassword;
                }
                api.put('member/' + id, data)
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/manage/members');
                        }
                    })
                    .catch(function (error) {
                        setLoadingData(false);
                    });
            }else{
                api.post('member' ,
                    {
                        first_name: FirstName,
                        last_name: LastName,
                        email: Email,
                        password: AccountPassword,
                        is_active: Enabled
                    })
                    .then(function (response) {
                        if (response.status == 200 || response.status == 204) {
                            toast.success('Successful Operation !', {
                                position: toast.POSITION.TOP_RIGHT
                            });
                            return history.push('/manage/members');
                        }
                    })
                    .catch(function (error) {
                        setLoadingData(false);
                    });
            }
        } catch (err) {
            setLoadingData(false);
        }
    }

    useEffect(() => {
        getById();
        var roles = [
            {
                id: 'ADMIN',
                name: 'ADMIN'
            },
            {
                id: 'CONTENT_MANAGER',
                name: 'CONTENT_MANAGER'
            },
            {
                id: 'FINANCE',
                name: 'FINANCE'
            },
            {
                id: 'VIEW_ONLY',
                name: 'VIEW_ONLY'
            },
        ];
        if(account != null && account.role == "RESONIC_ADMIN")
            roles.push({
                id: 'RESONIC_ADMIN',
                name: 'RESONIC_ADMIN'
            })

        setRoles(roles);
        var selector = document.getElementById('title-section-id');
        if(selector != undefined){
            if(id > 0)
                selector.textContent = "Edit user";
            else
                selector.textContent = "Create user";
        }
    }, []);

    return (
        <>
            <div className={loadingData ? "preload" : "d-none"}><div className="preloader-spinner"></div></div>
            <Form className="create-form" onSubmit={saveData} autoComplete="off">
                <div className="card">
                    <div className="card-body">
                        <div className="row">
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>First Name</Form.Label>
                                    <Form.Control name="first_name" type="text" required placeholder='First Name' value={FirstName} onChange={(e) => setFirstName(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Last Name</Form.Label>
                                    <Form.Control name="last_name" type="text" required placeholder='Last Name' value={LastName} onChange={(e) => setLastName(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control name="email" type="email" required placeholder='Email' value={Email} onChange={(e) => setEmail(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Role</Form.Label>
                                    <select className="form-control" name="Content" value={Role} onChange={(e) => setRole(e.target.value)}>
                                        {Roles.map((item, i) => (
                                            <option key={i} value={item.id}>{item.name}</option>
                                        ))}
                                    </select>
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Password {isEdit && <small className="text-muted">(leave blank to keep current)</small>}</Form.Label>
                                    <Form.Control name="password" type="password" required={!isEdit} placeholder='Password' value={AccountPassword} onChange={(e) => { setAccountPassword(e.target.value); setPasswordErrors([]); }} />
                                    {passwordErrors.length > 0 && (
                                        <ul className="text-danger mt-1 mb-0" style={{fontSize: '0.85em', paddingLeft: '1.2em'}}>
                                            {passwordErrors.map((err, i) => <li key={i}>{err}</li>)}
                                        </ul>
                                    )}
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Confirm Password</Form.Label>
                                    <Form.Control name="confirm_password" type="password" required={!isEdit || AccountPassword.length > 0} placeholder='Confirm Password' value={AccountConfirmPassword} onChange={(e) => setAccountConfirmPassword(e.target.value)} />
                                </Form.Group>
                            </div>
                            <div className="mb-3 col-md-6 col-sm-12">
                                <Form.Group className="form-group">
                                    <Form.Label>Enabled</Form.Label>
                                    <Form.Check name="is_active" type="checkbox" checked={Enabled} onChange={(e) => setEnabled(!Enabled)} />
                                </Form.Group>
                            </div>
                        </div>
                    </div>
                    <div className="card-footer">
                        <div className="row">
                            <div className="col-12 footer-form">
                                <NavLink className="btn btn-secondary" to="/manage/members"><i className="fa fa-fw fa-times"></i> Cancel</NavLink>
                                <Button className="btn btn-primary" type='submit'><i className="fa fa-fw fa-floppy-o"></i> Save</Button>
                            </div>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export default MemberForm;
